export default function FormatItalicIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 18}
      height={height ? height : width ? width : 18}
      viewBox="0 96 960 960"
    >
      <path
        fill="currentColor"
        d="M263.435 871.131q-20.7 0-35.438-14.778-14.737-14.778-14.737-35.537 0-20.522 14.737-34.995 14.738-14.473 35.438-14.473h86.652l135.043-397.13H379.696q-20.463 0-35.036-14.614t-14.573-35.136q0-20.522 14.573-34.995 14.573-14.474 35.036-14.474h300q20.463 0 35.036 14.614t14.573 35.136q0 20.522-14.573 34.996-14.573 14.473-35.036 14.473h-86.652l-135.043 397.13h105.434q20.463 0 35.036 14.674t14.573 35.283q0 20.608-14.573 35.217-14.573 14.609-35.036 14.609h-300Z"
      />
    </svg>
  );
}
